module.exports = "<svg viewBox=\"0 0 19.5 29.9\"><path d=\"M.1 29.9L15 15 0 0h4.5l15 15L4.6 29.9z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/wedge.svg
// module id = 308
// module chunks = 1